<div [routerLink]="getUrl()"
     class="flex flex-col  items-center gap-2 text-md rounded-xl drop-shadow-md hover:shadow-lg cursor-pointer p-4 border border-primary-500">
  <div class="text-primary-500">
    {{ service?.serviceName }}
  </div>
  <div class=" text-primary-500 flex items-center ">
    <mat-icon class="text-primary-500 align-middle scale-75" svgIcon="wizara"></mat-icon>
    <span> {{ service?.serviceProvider?.institutionName |titlecase }}</span>
  </div>
  <div class="w-10/12 text-md rounded-md flex items-center justify-center bg-primary-500/80 text-secondary-500  py-1.5 px-2">
    <span class="font-semibold text-md text-center">Ona zaidi</span>
  </div>
</div>
